<script>
    import { navigate } from 'svelte-routing';
    import { getItem } from '../helpers.svelte';
    export let itemIdentifier;

    $: item = getItem(itemIdentifier)

    const handleClick = (event) => {
        event.preventDefault();
        navigate(`/i/${item.id}`);
    }

</script>

<div>
    {#if item.title}
        <h3><a href={'#'} on:click="{handleClick}">{item.title}</a></h3>
    {/if}
</div>

